var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiIcDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E2E8F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9873,
    cy: 11.987,
    r: 6.144,
    fill: "#818CA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52986 9.83691C9.36019 9.83691 9.22266 9.97445 9.22266 10.1441V13.496C9.22266 13.6657 9.36019 13.8032 9.52986 13.8032H10.0429C10.2125 13.8032 10.3501 13.6657 10.3501 13.496V11.7906L11.8341 13.6854C11.8923 13.7598 11.9815 13.8032 12.076 13.8032H12.6781C12.8477 13.8032 12.9853 13.6657 12.9853 13.496V10.1441C12.9853 9.97445 12.8477 9.83691 12.6781 9.83691H12.1678C11.9981 9.83691 11.8606 9.97445 11.8606 10.1441V11.8411L10.4076 9.95655C10.3495 9.88111 10.2596 9.83691 10.1644 9.83691H9.52986Z",
    fill: "#F4F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0755 11.5394C13.9058 11.5394 13.7683 11.677 13.7683 11.8466V13.496C13.7683 13.6657 13.9058 13.8032 14.0755 13.8032H14.5696C14.7392 13.8032 14.8768 13.6657 14.8768 13.496V11.8466C14.8768 11.677 14.7392 11.5394 14.5696 11.5394H14.0755Z",
    fill: "#F4F6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0755 9.83691C13.9058 9.83691 13.7683 9.97445 13.7683 10.1441V10.6949C13.7683 10.8646 13.9058 11.0021 14.0755 11.0021H14.5696C14.7392 11.0021 14.8768 10.8646 14.8768 10.6949V10.1441C14.8768 9.97445 14.7392 9.83691 14.5696 9.83691H14.0755Z",
    fill: "#F4F6FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiIcDetail);
export default __webpack_public_path__ + "static/media/ni-ic-detail.e8ac79c59ee1f688fb3b7a270baf5d18.svg";
export { ForwardRef as ReactComponent };